import React, { lazy } from "react";
import Loadable from "components/Loadable";
import { routeConstants } from "services/keyConstants";
import BatchCheckListById from "../BatchCheckListById";

const ProductionAdditionalDescriptionDetail = Loadable(
  lazy(() => import("../ProductionAdditionalDescriptionDetail"))
);
const COAList = Loadable(lazy(() => import("../COAList")));
const ProductionAdditionalDescriptionList = Loadable(
  lazy(() => import("../ProductionAdditionalDescriptionList"))
);
const ProductionPlanningList = Loadable(
  lazy(() => import("../ProductionPlanningList"))
);
const StockRegisterList = Loadable(lazy(() => import("../StockRegisterList")));
const BMRById = Loadable(lazy(() => import("../BMRById")));
const COAById = Loadable(lazy(() => import("../COAById")));
const ProductManufacturingFormulaList = Loadable(
  lazy(() => import("../ProductManufacturingFormulaList"))
);
const BMRList = Loadable(lazy(() => import("../BMRList")));
const MaterialReconcliation = Loadable(
  lazy(() => import("../MaterialReconcliation"))
);
const ViewById = Loadable(lazy(() => import("../ViewById")));
const ProductList = Loadable(lazy(() => import("../ProductList")));
const BatchCheckList = Loadable(lazy(() => import("../BatchCheckList")));
const ProductAditionalDecsList = Loadable(
  lazy(() => import("../ProductAditionalDecsList"))
);
const RequisitionSlipList = Loadable(
  lazy(() => import("../RequisitionSlipList"))
);
const MaterialReconciliationlist = Loadable(
  lazy(() => import("../MaterialReconciliationlist"))
);

// Define routes using lazy-loaded components
const ProdRoutes = [
  {
    path: routeConstants.PRODUCTION,
    children: [
      { path: "production-planning", element: <ProductionPlanningList /> },
      { path: "requisition-slip-list", element: <RequisitionSlipList /> },
      {
        path: "product-manufacturing-formula-list",
        element: <ProductManufacturingFormulaList />,
      },
      { path: "bmr-list", element: <BMRList /> },
      {
        path: "material-reconciliation-list",
        element: <MaterialReconciliationlist />,
      },
      { path: "view/:id", element: <ViewById /> },
      { path: "coa/:bmrId", element: <COAById /> },
      { path: "view/:id/:variantId", element: <ViewById /> },
      { path: "reconciliation/:bmrId", element: <MaterialReconcliation /> },
      { path: "bmr/:id", element: <BMRById /> },
      { path: "product-list", element: <ProductList /> },
      { path: "batchCheckList/:type", element: <BatchCheckList /> },
      { path: "batchCheckList/:type/:Id", element: <BatchCheckListById /> },
      { path: "pad/:id?", element: <ProductionAdditionalDescriptionList /> },
      {
        path: "pad/detail/:id",
        element: <ProductionAdditionalDescriptionDetail />,
      },
      { path: "stock-register-list", element: <StockRegisterList /> },
      { path: "coa-list/:type", element: <COAList /> },
    ],
  },
];

export default ProdRoutes;
